import { render, staticRenderFns } from "./AccountantSupport.vue?vue&type=template&id=51a1c88b&scoped=true"
import script from "./AccountantSupport.vue?vue&type=script&lang=ts"
export * from "./AccountantSupport.vue?vue&type=script&lang=ts"
import style0 from "./AccountantSupport.vue?vue&type=style&index=0&id=51a1c88b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a1c88b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a1c88b')) {
      api.createRecord('51a1c88b', component.options)
    } else {
      api.reload('51a1c88b', component.options)
    }
    module.hot.accept("./AccountantSupport.vue?vue&type=template&id=51a1c88b&scoped=true", function () {
      api.rerender('51a1c88b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AccountantSupport.vue"
export default component.exports